import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './axios'
import VueAxios from 'vue-axios'

// 引入iconf
import './assets/icon/iconfont.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import utils from './plugins/utils.js'
import VueScrollReveal from 'vue-scroll-reveal';

Vue.use(VueScrollReveal, {
	class: 'v-scroll-reveal',
	duration: 2000,					// 执行时间
	origin: 'bottom',				// 动画开始的位置
	distance: '200px',				// 动画移动的距离
	mobile: false,					// 是否在移动端使用动画
	opacity: 0,
	reset: false,					// 回滚时是否再次触发动画
	beforeReset: (el) => {			// 还原前钩子
		// console.log("beforeReveal =>", el)
	},
	beforeReveal: (el) => {			// 显示前钩子
		// console.log("beforeReveal =>", el)

	},
	afterReset: (el) => {			
		// console.log("afterReset =>", el)
	},
	afterReveal: (el) => {
		// console.log("afterReveal =>", el)
	}
});

Vue.config.productionTip = false
Vue.prototype.$baseUrl = process.env.BASE_URL
Vue.prototype.$utils = utils

Vue.use(VueAxios, axios)
Vue.use(VueAwesomeSwiper)
// Vue.use(VueLazyload)

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
  }
}).$mount('#app')